export default __webpack_public_path__ + "images/01474356da55f64c8ca44ba2edc13972-county_government_small.webp";